import React from 'react';

export default ({applicationStatus, loadInProgress, user}) => (
  <section className='scene__scene-header detailsScene__scene-header'>
    <div className='go-back-to-list-header-button' onClick={() => {user.goToList(false)}}>Back</div>
    <header>
      Edit Component Details
    </header>
    {!loadInProgress &&
      <div
        className={`detailsScene__status-label ${applicationStatus.toLowerCase()}`}>{applicationStatus.toLowerCase()}
      </div>
    }
  </section>
);



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Edit/Header.jsx